<!-- src/components/ImageUploader.vue -->
<template>
    <div class="image-uploader">
      <v-card outlined>
        <v-card-title class="subtitle-1">封面图片</v-card-title>
        <v-card-text>
          <div v-if="!imageUrl" class="upload-area" @click="triggerFileInput">
            <v-icon large>mdi-image-plus</v-icon>
            <div class="mt-2">点击上传封面</div>
          </div>
          
          <div v-else class="preview-area">
            <v-img
              :src="imageUrl"
              max-height="200"
              contain
              class="mb-2"
            ></v-img>
            <v-btn
              color="error"
              small
              @click.stop="removeImage"
            >
              <v-icon left>mdi-delete</v-icon>
              移除图片
            </v-btn>
          </div>
          
          <input
            ref="fileInput"
            type="file"
            accept="image/*"
            style="display: none"
            @change="handleFileSelect"
          >
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ImageUploader',
    props: {
      imageUrl: {
        type: String,
        default: ''
      }
    },
    methods: {
      triggerFileInput() {
        this.$refs.fileInput.click()
      },
      
      handleFileSelect(event) {
        const file = event.target.files[0]
        if (file) {
          this.$emit('file-changed', file)
        }
      },
      
      removeImage() {
        this.$emit('file-changed', null)
        this.$refs.fileInput.value = ''
      }
    }
  }
  </script>
  
  <style scoped>
  .upload-area {
    border: 2px dashed #ddd;
    border-radius: 4px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s;
  }
  
  .upload-area:hover {
    border-color: #1976d2;
  }
  
  .preview-area {
    text-align: center;
  }
  </style>